import React from "react";
import { Button, Column, Columns, Modal, Section, Table, Title } from "@allxsmith/bestax-bulma";
import { readableDate } from "../../utils";
import { Link } from "react-router-dom";
import VehicleInspectionRow from "./VehicleInspectionRow";

export default function ExistingItemModal({
  open,
  setOpen,
  items,
  onContinue,
  vehicle,
  history,
  type,
  hideType
}) {
  const onClick = item => {
    let editUrl = item.itemType === "Job" ? "editjob" : "editquote";
    window.open(`/${editUrl}/${item.id}`, "_self");
    setOpen(false);
  };

  // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
  return (
    <Modal
      closeOnBlur
      active={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      <Modal.Content>
        <Section style={{ backgroundColor: "white" }}>
          <Title className="is-centered">
            Quotes/Jobs already in progress for this vehicle
          </Title>
          <Columns isMultiline>
            <Column>
              <Table>
                <thead>
                  <tr>
                    <th>Type</th>
                    <th>Description</th>
                    <th>Customer</th>
                    <th>Workshop</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map(item => (
                    <tr className="clickable" onClick={() => onClick(item)}>
                      <td>{item.itemType}</td>
                      <td>{item.description || item.job_description}</td>
                      <td>
                        {item.itemType === "Job"
                            ? item.is_defect
                                ? null
                                : item.customer2
                                    ? item.customer2.display_name
                                    : item.customer
                                      ? item.customer.display_name
                                      : ""
                            :
                            item.customer2
                                ? item.customer2.display_name
                                : item.customer
                                      ? item.customer.display_name
                                      : ""
                        }
                      </td>
                      <td>
                        {item.workshop ? item.workshop.display_name : ""}
                      </td>
                      <td>{readableDate(item.itemType === 'Job' ? item.workshop_date : item.provisional_start_date)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Column>
          </Columns>
          {vehicle && vehicle.id &&
            <Columns isMultiline>
              <Table isBordered isFullwidth>
                <thead>
                  <tr>
                    <th>Inspection Type</th>
                    <th>Inspection Workshop</th>
                    <th>Expiry Date</th>
                  </tr>
                </thead>
                <tbody>
                  {vehicle.inspections && vehicle.inspections.map(inspection => (
                      <VehicleInspectionRow
                        inspection={inspection}
                        view={"popup"}
                      />
                  ))}
                </tbody>
              </Table>
            </Columns>
          }
          <Columns isMultiline>
            <Column>
              <Button
                color="info"
                onClick={() => {
                  onContinue(vehicle);
                }}
                isFullWidth
              >
                Continue {hideType ? "" : "Creating " + type}
              </Button>
            </Column>
          </Columns>
        </Section>
      </Modal.Content>
    </Modal>
  );
}
